import { render, staticRenderFns } from "./ValidTweets.vue?vue&type=template&id=985bb876&scoped=true&"
import script from "./ValidTweets.vue?vue&type=script&lang=js&"
export * from "./ValidTweets.vue?vue&type=script&lang=js&"
import style0 from "./ValidTweets.vue?vue&type=style&index=0&id=985bb876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985bb876",
  null
  
)

export default component.exports